import { diff } from '@/utils/datetime';

export default (modifiedDate, today = null) => {
	modifiedDate =
		modifiedDate instanceof Date ? modifiedDate : new Date(modifiedDate);
	today = today instanceof Date ? today : new Date();

	if (modifiedDate.toDateString() === today.toDateString()) {
		return 'Today';
	}

	const toWords = val => {
		const words = [
			'',
			'One',
			'Two',
			'Three',
			'Four',
			'Five',
			'Six',
			'Seven',
			'Eight',
			'Nine',
			'Ten',
			'Eleven'
		];

		if (val == 0) {
			return '';
		}

		if (val > 11) {
			return val.toString();
		}

		return words[val];
	};

	const years = diff(modifiedDate, today, 'year');
	const months = diff(modifiedDate, today, 'month');
	const days = diff(modifiedDate, today, 'day');
	const weeks = diff(modifiedDate, today, 'week');

	switch (true) {
		case days === 1:
			return 'Yesterday';
		case days < 7 && weeks === 0:
			return `${toWords(days)} days ago`;
		case weeks === 1:
			return 'Last week';
		case months === 1:
			return 'Last month';
		case weeks > 1 && months === 0:
			return `${toWords(weeks)} weeks ago`;
		case years == 1:
			return 'Last year';
		case years > 1:
			return `${toWords(years)} years ago`;
		default:
			return `${toWords(months)} months ago`;
	}
};
